export const GRAMATIK_PROXY =
  process.env.REACT_APP_GRAMATIK_PROXY ||
  "0x9fE46736679d2D9a65F0992F2272dE9f3c7fa6e0";

export const PROOF_PATH =
  process.env.REACT_APP_PROOF_PATH || "/merkle.1.0.0.test.json";

export const SNAP_PATH =
  process.env.REACT_APP_SNAP_PATH || "/test-snap-shot.json";
